module.exports = __webpack_public_path__ + "static/media/14_LauraZeiger_webfinal.4225cf31.jpg";